// import 'react-app-polyfill/ie11';
// import 'core-js/actual/promise';
// import 'core-js/actual/set';
// import 'core-js/actual/iterator';
// import 'core-js/actual/array/from';
// import 'core-js/actual/array/flat-map';
// import 'core-js/actual/structured-clone';
import React from "react";
import ReactDOM from "react-dom/client";  
import "client/client.css";
import "./color.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
import 'react-perfect-scrollbar/dist/css/styles.css';
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persister, store } from "./store";
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <PersistGate persistor={persister}>
        <BrowserRouter basename="/internet-banking">
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
